import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import ProductRecommendationsQuery from '../../components/ProductRecommendationsQuery.gql';
import { RecommendationsWrapper } from '../ProductRecommendations';
import { Title } from '../ContentComponents/Title';
import { Spacer } from '../ContentComponents/Spacer';
import { ProductRow, ProductRowItem } from '../ContentComponents/ProductRow';
import { useIntl } from '@jetshop/intl';
import { ProductCard } from '../CategoryPage/ProductCard';
import { Above } from '@jetshop/ui/Breakpoints';

export const RelatedProductsFromCustomFields = ({ products }) => {
  const articleNumbers = products?.map(product => product);
  const relatedProductsResult = useQuery(ProductRecommendationsQuery, {
    variables: {
      articleNumbers
    },
    skip: articleNumbers?.length === 0,
    errorPolicy: 'ignore'
  });

  const t = useIntl();
  const relatedProductsString = t('Related products');

  return (
    <RecommendationsWrapper className="recommendations">
      <div className="title-wrapper">
        <Title text={{ value: relatedProductsString }} />
      </div>
      <Spacer height={{ value: 'SMALL' }} />

      {relatedProductsResult?.data?.products?.length > 0 &&
        (relatedProductsResult?.data?.products?.length < 4 ? (
          <>
            <Above breakpoint="lg">
              {matches =>
                matches ? (
                  <section>
                    {relatedProductsResult?.data?.products?.map(
                      (product, index) => {
                        return <ProductCard product={product} key={index} />;
                      }
                    )}
                  </section>
                ) : (
                  <ProductRow>
                    {relatedProductsResult?.data?.products?.map(
                      (product, index) => {
                        return (
                          <div key={'product-row-item-' + index}>
                            <ProductRowItem
                              product={product}
                              className="custom-product-item"
                            />
                          </div>
                        );
                      }
                    )}
                  </ProductRow>
                )
              }
            </Above>
          </>
        ) : (
          <ProductRow>
            {relatedProductsResult?.data?.products?.map((product, index) => {
              return (
                <div key={'product-row-item-' + index}>
                  <ProductRowItem
                    product={product}
                    className="custom-product-item"
                  />
                </div>
              );
            })}
          </ProductRow>
        ))}
    </RecommendationsWrapper>
  );
};
